import CardsContainer from "./CardsContainer/CardsContainer";
import FinalRisk from "./FinalRisk/FinalRisk";
import PolicyViolations from "./PolicyViolations";
import ThreatsDetected from "./ThreatsDetected";
import Vulnerabilities from "./Vulnerabilities";
export default {
    Container: CardsContainer,
    FinalRisk,
    PolicyViolations,
    ThreatsDetected,
    Vulnerabilities,
};
//# sourceMappingURL=SummaryCards.js.map